<script setup>

import {onMounted, ref, nextTick, computed} from "vue";
import {storeToRefs}                        from "pinia";
import {useMainStore}                       from "../stores/main";
    let progress= ref(50);
    let xPos = ref(0);
    let dir = ref(1);
    let speed = ref(1);
    let nInterval = null;

    let store = useMainStore();

    const { lang } = storeToRefs(store)

    function start ()
    {
        clearInterval(nInterval);
        speed.value = 1;
        dir.value = 1;

        nInterval = setInterval(() => {
            progress.value += dir.value ;

            if (progress.value >= 100)
            {
                dir.value = -1
            }

            if (progress.value <= 0)
            {
                dir.value = 1
                xPos.value = 0;
            }

            if (dir.value === -1)
            {
                xPos.value = 100 - progress.value;
            }
        }, 10)}

    function stop ()
    {
        clearInterval(nInterval);
    }

    defineExpose({start, stop})

    onMounted(() => {
        start();
    });


    let srcLogo = computed ( () => {

        if (lang.value === 'fr')
            return "/images/mazaam-emotions.svg";

        return "/images/mazaam-emotions-en.svg";
    })
</script>

<template>
    <div class="progress-container">
        <img :src="srcLogo" alt="Progress Image" class="progress-image"/>
        <div class="progress-bar" :style="{ width: progress + '%', left: xPos + '%' }"></div>
        <!--        <div>Chargement en cours / Loading</div>-->
    </div>
</template>

<style scoped>
.progress-container {
    position: absolute;
    left:37.5%;
    width: 25%;
    height: 20px;
    background-color: hsl(122, 39%, 79%);
    box-sizing: border-box; /* Includes padding and border in the width and height */
    outline: 10px solid white; /* A white border outside the content */
    outline-offset: 0px;
    border-radius: 10px;

    top: 50%;
    transform: translateY(-50%);
}

.progress-bar {
    position: absolute;
    background: hsl(122, 39%, 49%);
    height: 100%;
    border-radius: 10px;
}



.progress-image {
    position: absolute;
    top: calc(50% - 125px);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 250px; /* Width of your image */

}
</style>
